import getConfig from "next/config";
import { AxiosRequestConfig, Method } from "axios";

/**
 * formatMuseLocationResponse: Formatter for Muse locations.
 * This is the default.
 */
const formatMuseLocationResponse = (content: any[]) => {
    if (!content?.length) {
        return [];
    }

    return content.map((location: any) => ({
        label: location?.label,
        latitude: location?.latitude,
        longitude: location?.longitude,
        remote_work_location_type: location?.remote_work_location_type,
        value: location?.label,
        id: null
    }));
};

/**
 * formatLocations: Cleanup the results from a location request for use within the location suggestor.
 * formerly formatLocationResponse
 */
const formatLocations = (content: any[]) => formatMuseLocationResponse(content);

/**
 * Returns the Axios config for requesting locations from TheMuse.
 */
const getMuseLocationConfig = (searchText: string): AxiosRequestConfig => {
    const { publicRuntimeConfig: { apiBase, apiRequestTimeoutMs } } = getConfig();
    return {
        url: `${apiBase}/locations?query=${searchText}`,
        method: ("GET" as Method),
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json"
        },
        timeout: apiRequestTimeoutMs
    };
};

/**
 * Returns the Axios config for requesting locations.
 */
const getLocationConfig = (searchText: string): AxiosRequestConfig => {
    const config = getMuseLocationConfig(searchText);
    return config;
};

export { formatLocations, getLocationConfig };
